// extracted by mini-css-extract-plugin
export default {"advertCardFooter":"c-a_hB","advertCardFooter__row":"c-a_hC","advertCardFooter__name":"c-a_hE","advertCardFooter__price":"c-a_hF","advertCardFooter__age":"c-a_hG"};